import { r_expand } from './navigation';
import createPdfViewer from './pdfViewer';
import { v } from './viewport';

let products = window.products;
const setProducts = (data) => window.setProducts(data);
const focusObjects = window.focusObjects;
const productsRoute = window.productsRoute;

export const reqProducts = async () => {
    if(!window.products.length > 0) {
        const data = await axios.get(productsRoute);
        window.setProducts(data.data);
        //products = data.data;
        window.products.sort(compare);
        console.log(window.products)
    }

    const clickable = [];

    v.root.map(x => {
        if(x.name.charAt('4') === '1') {
            clickable.push(x)
        } else if (x.parent && x.parent.name.charAt('4') === '1') {
            clickable.push(x)
        }
    })

    v.createOutlineRaycaster(clickable);

    canvas.addEventListener('clickedObj', e => {
        expand();
        $('.rightAside-wide-inner-inner').remove();
        window.products.forEach(x => {
            if(x.id === e.detail.obj.name) {
                createExpanded(x, 'rightAside-wide-inner');
            }
        });
        focus(e.detail.obj);
    });
}

const focus = (obj) => {
    focusObjects.map(x => {
        if(x.name === obj.name)  {
            if(x.box) {
                v.focusObject(x.pos, x.box);
            } else {
                const box = v.getCenter(obj);
                v.focusObject(x.pos, box);
            }
            
        }
    })
}

function compare(a,b) {
    if (a.id > b.id)
       return -1;
    if (a.id < b.id)
      return 1;
    return 0;
}

export const createCards = () => {
    window.products.forEach(x => {
        createCard(x, 'products')
    })
}

const createCard = (obj, location) => {
    const id = obj.id.substring(0, 5);
    $(`#${location}`).append(getCardBoilerplate(obj, id))
    $(`#card-${id}`).on('click', () => {
        expand(obj)
        createExpanded(obj, 'rightAside-wide-inner');
        focus(v.objects.find(x => x.name === obj.id));
    }
    );
}

const expand = (obj) => {
    r_expand();
}

const createExpanded = (obj, location) => {
    $(`#${location}`).append(getExpandedBoilerplate(obj));
    if(obj.video) {
        setTimeout(() => {
            $(`.rightAside-wide-inner-inner`).append(getVideoBoilerplate(obj));
        }, 300)
    }
    if(obj.documents) {
        setTimeout(() => {
            obj.documents.forEach( (x, i) => {
                createPdfViewer(x, `pdf${i}`, 'rightAside-wide-inner-inner');
            })
        }, 300)
    }
}

const getCardBoilerplate = (obj, id) => {
    return `
        <div id="card-${id}" class="card">
            <img src="${obj.img}" class="card-img-top" style="width: 200px; height: 200px;" alt="...">
            <div class="card-body mb-2">
                <h5 class="card-title">${obj.name}</h5>
                <h6 class="card-subtitle">${obj.manufacturer}</h6>
            </div>
        </div>
    `
}

const getExpandedBoilerplate = (obj) => {
    return `
        <div id="rightAside-wide-inner-inner" class="rightAside-wide-inner-inner">
            <div class="wide-header">
                <h1 class="wide-title text-center">${obj.name}</h1>
                <img src="${obj.logo}" class="wide-logo" alt="logo">
            </div>
            <img src="${obj.img}" class="wide-img" alt="image">
            <div class="wide-desc text-center">
                ${obj.description}
            </div>
        </div>
    `
}

const getVideoBoilerplate = (obj) => {
    return `
        <div class="embed-responsive embed-responsive-16by9">
            <iframe class="embed-responsive-item" src="${obj.video}" allowfullscreen></iframe>
        </div>
    `
}